/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import React from 'react';

import { EMAIL, PHONE_NUMBER, WEBSITE } from '../../const';
import cleanUrl from '../../utils/cleanUrl';
import useClubDetailsStyle from '../ClubDetails/styles';
import ExternalLink from '../ExternalLink';
import { Email, Phone, Website } from '../Icons';
import Text from '../Text';
import useStyles from './styles';

export const contactClubRef = React.createRef();

const DETAILS_MAPPING = {
  [EMAIL]: { icon: Email, prefix: 'mailto:' },
  [WEBSITE]: { icon: Website },
  [PHONE_NUMBER]: { icon: Phone, prefix: 'tel:' },
};

const normaliseContactDetails = details => {
  if (!Object.keys(details)) {
    return [];
  }

  return Object.keys(details).map(detailKey => ({
    icon: DETAILS_MAPPING[detailKey].icon,
    text: cleanUrl(details[detailKey]),
    href: `${DETAILS_MAPPING[detailKey].prefix || ''}${details[detailKey]}`,
    detailKey,
  }));
};

const ClubDetailsContactDetails = ({ contactDetails }) => {
  const styles = useStyles();
  const stylesClubDetails = useClubDetailsStyle();
  const details =
    contactDetails?.details && normaliseContactDetails(contactDetails?.details);

  return (
    <div ref={contactClubRef} css={styles.contactDetailsCont}>
      {details && details.length > 0 && (
        <>
          <Text as="h3" css={styles.title}>
            Contact details
          </Text>
          {contactDetails?.name && (
            <div css={stylesClubDetails.group}>
              <div css={stylesClubDetails.groupLabel}>Name</div>
              <div css={stylesClubDetails.groupValue}>
                {contactDetails?.name && contactDetails.name}
              </div>
            </div>
          )}
          {details.map(detail => {
            const { href: link } = detail;
            return (
              <div css={stylesClubDetails.group} key={detail.text}>
                <div css={stylesClubDetails.groupLabel}>{detail.detailKey}</div>
                <div css={stylesClubDetails.groupValue}>
                  <ExternalLink
                    href={link}
                    css={styles.link}
                    aria-label={`Link - opens in a new window`}
                    target="_blank"
                    rel="noopener"
                    id={`contact_details_${detail.detailKey.toLowerCase()}`}
                  >
                    {detail.text}
                  </ExternalLink>
                </div>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

ClubDetailsContactDetails.propTypes = {
  contactDetails: PropTypes.object,
};

export default ClubDetailsContactDetails;
